export default __webpack_public_path__ + "static/img-asia-blockchain-media-bfcdd16bfd7f03e53da12ca527c5276d.png";